// extracted by mini-css-extract-plugin
export default {"submitting":"DefaultLayout_submitting__dHeAG"};